// removed by extract-text-webpack-plugin
module.exports = {"ProjectListLink":"ProjectList__ProjectListLink--1oGWa","SearchWrapper":"ProjectList__SearchWrapper--2Zo34","SearchField":"ProjectList__SearchField--3c64b","SearchIcon":"ProjectList__SearchIcon--3lXeL"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ProjectList/ProjectList.scss
// module id = 414
// module chunks = 0